// Profile Snapshots — portal entry (owned by the snapshots feature).
// /snapshots (take one by username + every snapshot) and /snapshots/:snapshotId (one snapshot).
// The CRM contact panel shows ContactSnapshotCard.
import { ScanSearch } from "lucide-react";
import { RequireIgAccount } from "../../lib/igAccount";
import type { FeatureModule } from "../registry";

const snapshots: FeatureModule = {
  id: "snapshots",
  nav: [{ to: "/snapshots", label: "Profile Snapshots", icon: ScanSearch, group: "pipeline", order: 22 }],
  routes: [
    {
      path: "/snapshots",
      lazy: async () => {
        const { SnapshotsPage } = await import("./SnapshotsPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <SnapshotsPage />
            </RequireIgAccount>
          ),
        };
      },
    },
    {
      path: "/snapshots/:snapshotId",
      lazy: async () => {
        const { SnapshotPage } = await import("./SnapshotPage");
        return {
          Component: () => (
            <RequireIgAccount>
              <SnapshotPage />
            </RequireIgAccount>
          ),
        };
      },
    },
  ],
};

export default snapshots;
